"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewQuerie = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _utils = require("../../../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchPreviewQuerie = ({
  searchPhrase,
  text,
  showIcon = true,
  onClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const label = (0, _react.useMemo)(() => {
    const textWithBoldPhrase = (0, _utils.boldMatchedText)({
      searchPhrase,
      text
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Label, {
      color: "textPrimary",
      children: textWithBoldPhrase
    });
  }, [searchPhrase, text]);
  const icon = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SearchIcon, {}), []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledChip, {
    variant: "rounded",
    "data-testid": getTestId(_constants.SEARCH_PREVIEW_QUERIE),
    label: label,
    icon: showIcon ? icon : undefined,
    onClick: onClick
  });
};
exports.SearchPreviewQuerie = SearchPreviewQuerie;
